<template>
	<!-- App's main menu component -->
	<ul id="menu-bar" class="metismenu side-nav">
		<template v-for="item in menuItems">
			<template v-if="item.header && mode !== 'horizontal'">
				<li
					:key="`item-${item.name}-header`"
					class="side-nav-title side-nav-item"
				>
					{{ item.header }}
				</li>
			</template>
			<li :key="`item-${item.name}`" class="side-nav-item">
				<!-- TODO: Add support for sub-items -->
				<template>
					<component
						:is="item.disabled ? 'span' : 'router-link'"
						tag="a"
						:to="`${item.path.split(':')[0]}`"
						:class="`side-nav-link side-nav-link-ref ${
							item.disabled ? 'disabled' : ''
						}`"
					>
						<i v-if="item.icon" :class="item.icon" />
						<span>{{ $t(`PORTAL.${item.name}.heading`) }}</span>
						<span
							v-if="item.badge"
							:class="
								'badge badge-' +
								item.badge.variant +
								' float-right font-size-11'
							"
							>{{
								$t(`PORTAL.Home.badge.${item.badge.text}`)
							}}</span
						>
					</component>
				</template>
			</li>
		</template>
	</ul>
</template>

<script>
import { authProtectedRoutes } from '@/router/routes'
import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
	props: {
		mode: {
			type: String,
			default: 'vertical'
		}
	},
	data() {
		return {
			menuItems: authProtectedRoutes,
			menuRef: null
		}
	},
	mounted() {
		// TODO: Can be removed once we've decided on a final layout.
		if (this.mode === 'horizontal') {
			const menuRef = new MetisMenu('#menu-bar').on(
				'shown.metisMenu',
				function (event) {
					window.addEventListener('click', function menuClick(e) {
						if (!event.target.contains(e.target)) {
							menuRef.hide(event.detail.shownElement)
							window.removeEventListener('click', menuClick)
						}
					})
				}
			)
			this.menuRef = menuRef
		} else {
			this.menuRef = new MetisMenu('#menu-bar')
		}

		const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active'
		this.activateMenuItems(activeClass)
	},
	methods: {
		activateMenuItems(activeClass) {
			const links = document.getElementsByClassName('side-nav-link-ref')

			let menuItemEl = null
			let path = this.$route.path
			// Get page path:
			const paths = path.split('/')
			if (paths.length > 1) {
				path = paths[1]
			}
			for (let i = 0; i < links.length; i++) {
				if (links[i].href.includes(path)) {
					menuItemEl = links[i]
					break
				}
			}

			if (menuItemEl) {
				menuItemEl.classList.add('active')
				const parentEl = menuItemEl.parentElement
				if (parentEl) {
					parentEl.classList.add(activeClass)
					// TODO: Add support for sub-items
				}
			}
		}
	}
}
</script>

<style scoped>
.disabled {
	cursor: not-allowed;
	color: #6c757d;
}
.disabled:hover {
	color: #6c757d;
}
</style>
